import React from 'react'
import { withCookies } from 'react-cookie'
import {
  Form,
  Button,
  Select,
  Radio,
  Checkbox,
  InputNumber,
  Upload,
  Input,
  Space,
  DatePicker as PcDatePicker,
  Switch,
  Table,
  Cascader,
  Spin,
  TimePicker,
} from 'antd'
import { LoadingOutlined, UploadOutlined } from '@ant-design/icons'
import { previewFileByOW365, getFirstWord } from '../ShareUtils'
import { Picker, List, Toast, DatePicker, TextareaItem } from 'antd-mobile'
import moment from 'moment'
import Zmage from 'react-zmage'

import styles from './approvedialog.module.css'

import {
  _getNextFlowNodes,
  _getPreFlowNodes,
  _uploadByWx,
  _ocrVatInvoice,
} from '../../server'
import { SelectMember } from '../MyModals'
import { genId, getWxSignature, isQiyeweixinApp } from '../ShareUtils'
import { _getDownloadPath } from '../CommonUtils'
import { InvoiceComponent } from '../MyComs'

const { Option } = Select
const CheckboxGroup = Checkbox.Group

const ALI_OSS_DOWNLOAD = process.env.ALI_OSS_DOWNLOAD

class ApproveDialog extends React.Component {
  constructor(props) {
    super(props)
    const { cookies } = this.props
    this.sid = cookies.get(process.env.TOKEN_KEY)
    this.actionName = '确定'
    let actionDesc = '确认'
    if (this.props.actionType === 1) {
      this.actionName = '审批'
      actionDesc = '同意。'
    } else if (this.props.actionType === 2) {
      this.actionName = '退审'
      actionDesc = '不同意。'
    } else if (this.props.actionType === 0) {
      this.actionName = '关闭'
      actionDesc = '已完成。'
    } else if (this.props.actionType === 3) {
      this.actionName = '加签'
      actionDesc = '请协助处理。'
    } else if (this.props.actionType === 4) {
      this.actionName = '加签'
      actionDesc = '请协助处理。'
    }
    this.state = {
      actionDesc: actionDesc,
      nextFlowNodes: [],
      preFlowNodes: [],
      backFlowNode: 0,
      exFields: [],
      selectedData: [],
      selectedExtra: {},
      signUsers: [],
      signType: 1,
      isSubmitting: false,
      allowApprovalComments: this.props.allowApprovalComments,
      removeFileList: [],
      lastRecognizedList: [],
    }
    if (this.props.actionType === 1) {
      this.getNextFlowNodes()
    } else if (this.props.actionType === 2) {
      this.getPreFlowNodes()
    } else if (this.props.actionType === 4) {
      this.state.signType = 2
    }
  }

  componentDidMount() {
    if (this.props.exFields) {
      this.props.exFields.map((item, index) => {
        if (!item.inputValue) {
          item.inputValue = []
          if (item.selectedValue) {
            item.inputValue = [item.selectedValue]
          }
        }
        if (!item.multipleValue) {
          item.multipleValue = []
        } else if (typeof item.multipleValue === 'string') {
          item.multipleValue = JSON.parse(item.multipleValue)
        }
      })
      this.setState({ exFields: this.props.exFields })
    }
  }

  componentWillUnmount() {}

  async getPreFlowNodes() {
    const res = await _getPreFlowNodes(
      this.sid,
      this.props.formDataId,
      this.props.currentNode.id
    )
    if (res.code === 0) {
      this.setState({
        preFlowNodes: res.data.tFlowNodeList,
        backFlowNode: res.data.tFlowNodeList[0].value,
      })
    } else {
      Toast.offline(res.msg + '，请稍后重试', 3)
    }
  }

  async getNextFlowNodes() {
    const res = await _getNextFlowNodes(
      this.sid,
      this.props.formDataId,
      this.props.currentNode.id
    )
    if (res.code === 0) {
      this.setState({ nextFlowNodes: res.data.tFlowNodeList })
    }
  }

  onCommonChange = (e, data) => {
    data.inputValue = [e.target.value]
    this.updateExField(data)
  }

  onPickerChange = (e, data) => {
    data.inputValue = e
    this.updateExField(data)
  }

  onCheckBoxChange = (checkedList, data) => {
    data.inputValue = checkedList
    this.updateExField(data)
  }

  updateExField = (data) => {
    this.state.exFields.map((item, index) => {
      if (item.fieldId == data.fieldId) {
        item = data
      }
    })
    this.setState({ exFields: this.state.exFields })
  }

  onTextAreaChange = (value, data) => {
    data.inputValue = [value]
  }

  bindRef = (ref) => {
    this.selectMemberModal = ref
  }

  onSignTypeChange = (e) => {
    this.setState({ signType: e.target.value })
  }

  updateSelectedData = (extra, list) => {
    switch (extra.type) {
      case 2:
        this.state.exFields.map((item, index) =>
          item.fieldId === extra.data.fieldId ? (item.inputValue = list) : ''
        )
        this.setState({ exFields: this.state.exFields })
        break
      case 3:
        //加签
        this.setState({ signUsers: list })
        break
      default:
        // code...
        break
    }
  }

  chooseImage = (data) => {
    window.wx.chooseImage({
      count: 9,
      sizeType: ['original', 'compressed'],
      sourceType: ['album', 'camera'],
      defaultCameraMode: 'batch',
      isSaveToAlbum: 1,
      success: (res) => {
        var localIds = res.localIds
        if (localIds) {
          for (var i = 0; i < localIds.length; i++) {
            var item = localIds[i]
            window.wx.uploadImage({
              localId: item,
              isShowProgressTips: 1,
              success: (res) => {
                var serverIds = [res.serverId]
                this.uploadByWx(data, serverIds)
              },
            })
          }
        }
      },
    })
  }

  previewImage = (list, data) => {
    var urls = []
    if (list && list.length > 0) {
      list.map((item) => {
        urls.push(
          process.env.API_HOST +
            '/file/download?fileUrl=' +
            item.url +
            '&fileName=' +
            item.name
        )
      })
    } else {
      urls.push(
        process.env.API_HOST +
          '/file/download?fileUrl=' +
          data.url +
          '&fileName=' +
          data.name
      )
    }
    window.wx.previewImage({
      current:
        process.env.API_HOST +
        '/file/download?fileUrl=' +
        data.url +
        '&fileName=' +
        data.name,
      urls: urls,
    })
  }

  async uploadByWx(data, serverIds) {
    const res = await _uploadByWx(this.sid, serverIds)
    if (res.code === 0) {
      if (!data.inputValue) {
        data.inputValue = []
      }
      if (res.data.values) {
        res.data.values.map((item) => {
          data.inputValue.push(item)
        })
      }
      this.updateExField(data)
    }
  }

  addImageOnClick(data) {
    this.chooseImage(data)
  }

  onUploadChange = (info, data) => {
    if (info.file.response && info.file.response.code === 0) {
      info.file.url = info.file.response.data.fileUrl
      var fileList = []
      info.fileList.map((item) => {
        if (!item.url && item.response && item.response.data) {
          item.url = item.response.data.fileUrl
        }
        if (item.type === 'image/png') {
          item.thumbUrl = item.url
        }
        if (item.url) {
          fileList.push(item)
        }
      })
      data.inputValue = fileList
      this.updateExField(data)
    }
  }

  async ocrVatInvoice(fileUrlList, data) {
    if (fileUrlList) {
      var newFileUrlList = []
      for (let index = 0; index < fileUrlList.length; index++) {
        const thumbUrl = fileUrlList[index]
        var isAppend = true
        data.inputValue.map((item) => {
          if (item.invoiceInfo && item.invoiceInfo.words_result_num > 0) {
            if (item.thumbUrl === thumbUrl) {
              isAppend = false
            }
          }
        })
        if (isAppend) {
          newFileUrlList.push(thumbUrl)
        }
      }

      Toast.info('正在识别' + newFileUrlList.length + '张发票...', 300)
      const res = await _ocrVatInvoice(this.sid, newFileUrlList)
      if (res.code === 0) {
        var successNum = 0
        var tErrorNum = 0
        var newInputValue = []
        for (var i = 0; i < data.inputValue.length; i++) {
          data.inputValue[i].ocrStatus = true
          if (data.inputValue[i].url && res.data[data.inputValue[i].url]) {
            var invoiceInfo = res.data[data.inputValue[i].url]
            if (invoiceInfo.TErrorMsg) {
              if (
                this.state.removeFileList.indexOf(data.inputValue[i].url) < 0
              ) {
                this.state.removeFileList.push(data.inputValue[i].url)
                this.setState({ removeFileList: this.state.removeFileList })
              }
              tErrorNum++
              successNum++
              newInputValue.push(data.inputValue[i])
              continue
            } else {
              var isHas = false
              for (let j = 0; j < data.inputValue.length; j++) {
                const element = data.inputValue[j]
                if (element.invoiceInfo) {
                  let ekey = 'InvoiceNum'
                  const etype =
                    getFirstWord(element.invoiceInfo, 'result_type', '') ||
                    element.invoiceInfo.result_type
                  if (etype === 'vat_invoice') {
                    ekey = 'InvoiceNum'
                  } else if (etype === 'air_ticket') {
                    ekey = 'invoice_num'
                  } else if (etype === 'taxi_receipt') {
                    ekey = 'InvoiceNum'
                  } else if (etype === 'train_ticket') {
                    ekey = 'invoice_num'
                  } else if (etype === 'quota_invoice') {
                    ekey = 'invoice_number'
                  } else if (etype === 'printed_invoice') {
                    ekey = 'InvoiceNum'
                  } else if (etype === 'roll_normal_invoice') {
                    ekey = 'InvoiceNum'
                  } else if (etype === 'motor_vehicle_invoice') {
                    ekey = 'fapiao-haoma'
                  } else if (etype === 'used_vehicle_invoice') {
                    ekey = 'invoice_num'
                  }
                  const eInvoiceNum = getFirstWord(
                    element.invoiceInfo,
                    ekey,
                    ''
                  )
                  let vkey = 'InvoiceNum'
                  const vtype =
                    getFirstWord(invoiceInfo, 'result_type', '') ||
                    invoiceInfo.result_type
                  if (vtype === 'vat_invoice') {
                    vkey = 'InvoiceNum'
                  } else if (vtype === 'air_ticket') {
                    vkey = 'invoice_num'
                  } else if (vtype === 'taxi_receipt') {
                    vkey = 'InvoiceNum'
                  } else if (vtype === 'train_ticket') {
                    vkey = 'invoice_num'
                  } else if (vtype === 'quota_invoice') {
                    vkey = 'invoice_number'
                  } else if (vtype === 'printed_invoice') {
                    vkey = 'InvoiceNum'
                  } else if (vtype === 'roll_normal_invoice') {
                    vkey = 'InvoiceNum'
                  } else if (vtype === 'motor_vehicle_invoice') {
                    vkey = 'fapiao-haoma'
                  } else if (vtype === 'used_vehicle_invoice') {
                    vkey = 'invoice_num'
                  }
                  const vInvoiceNum = getFirstWord(invoiceInfo, vkey, '')
                  if (eInvoiceNum == vInvoiceNum) {
                    isHas = true
                    break
                  }
                }
              }
              if (isHas) {
                if (
                  this.state.removeFileList.indexOf(data.inputValue[i].url) < 0
                ) {
                  this.state.removeFileList.push(data.inputValue[i].url)
                  this.setState({ removeFileList: this.state.removeFileList })
                }
                tErrorNum++
                successNum++
                newInputValue.push(data.inputValue[i])
                continue
              }
              successNum++
              data.inputValue[i].invoiceInfo = invoiceInfo
            }
          }
          newInputValue.push(data.inputValue[i])
        }
        data.inputValue = JSON.parse(JSON.stringify(newInputValue))
        if (successNum > 0) {
          Toast.info('成功识别' + successNum + '张发票', 2)
        }
        if (tErrorNum > 0) {
          setTimeout(() => {
            Toast.info(tErrorNum + '张发票重复，已禁止上传', 3)
          }, 2000)
        }

        this.updateExField(data)
      } else {
        Toast.info('识别失败，请重试', 1)
      }
    }
  }

  onOcrVatInvoiceChange = async (info, data) => {
    if (!info) return

    let fileList = info.fileList.map((f) => {
      // 上传完成时修正 url
      if (f.status === 'done' && !f.url) {
        if (f.response && f.response.data) {
          f.url = f.response.data.fileUrl
        }
      }
      return f
    })

    // ========== 在判断是否全部上传完成之前排除 removeFileList ==========
    const removedUrls = this.state.removeFileList || []
    fileList = fileList.filter((f) => !removedUrls.includes(f.url))

    // ----------- 判断是否全部上传完成 -------------------
    const allDone = fileList.every((f) => f.status === 'done')

    // 更新 inputValue
    data.inputValue = fileList
    this.updateExField(data)

    // ---------- 如果没全部完成，不识别 ----------
    if (!allDone) return

    // ---------- 全部完成，再统一识别 ----------
    const newFileUrls = fileList.map((f) => f.url)
    let newFiles = newFileUrls.filter((f) => {
      return this.state.lastRecognizedList.indexOf(f) < 0
    })

    if (newFiles.length > 0) {
      await this.ocrVatInvoice(newFiles, data)
      // 更新 lastRecognizedList
      this.setState({
        lastRecognizedList: [
          ...new Set(this.state.lastRecognizedList.concat(newFiles)),
        ],
      })
    }

    if (data.inputValue) {
      for (let index = data.inputValue.length - 1; index >= 0; index--) {
        const element = data.inputValue[index]
        if (element.status === 'done') {
          var isHas = false
          for (let i = 0; i < fileList.length; i++) {
            const ele = fileList[i]
            if (ele.url && ele.url === element.url) {
              isHas = true
              break
            }
          }
          if (!isHas) {
            fileList.unshift(element)
          }
        }
      }
    }

    data.inputValue = fileList
    this.updateExField(data)
  }

  renderExField = (data) => {
    switch (data.fieldType) {
      case 'TextField':
        if (data.inputValue.length === 0) {
          if (data.defaultValue) {
            data.inputValue = [data.defaultValue]
          } else {
            data.inputValue = ['']
          }
        }
        return (
          <input
            onBlur={() => window.scrollTo(0, 0)}
            type="text"
            maxLength="2000"
            className={styles.textField}
            value={data.inputValue[0]}
            onChange={(e) => this.onCommonChange(e, data)}
          />
        )
      case 'TextArea':
        if (data.inputValue.length === 0) {
          if (data.defaultValue) {
            data.inputValue = [data.defaultValue]
          } else {
            data.inputValue = ['']
          }
        }
        return (
          <div className={styles.textareaField}>
            <TextareaItem
              onBlur={() => window.scrollTo(0, 0)}
              editable={!data.isReadOnly}
              rows={3}
              onChange={(value) => this.onTextAreaChange(value, data)}
            ></TextareaItem>
          </div>
        )
      case 'RadioButton':
        return (
          <Radio.Group
            value={data.inputValue[0]}
            className={styles.choiceField}
            onChange={(e) => this.onCommonChange(e, data)}
          >
            {data.multipleValue.map((item, index) => (
              <div
                key={index}
                className={styles.choiceFieldItem}
                style={{ width: 100 / data.showType + '%' }}
              >
                <Radio
                  value={item.name}
                  style={{
                    display: 'block',
                    width: '100%',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                  }}
                >
                  {item.name}
                </Radio>
              </div>
            ))}
          </Radio.Group>
        )
      case 'DropDown':
        const dropDownData = []
        data.multipleValue.map((item, index) => {
          dropDownData.splice(index, 0, { label: item.name, value: item.name })
        })
        return (
          <Picker
            data={dropDownData}
            extra={data.tip}
            cols={1}
            onChange={(e) => this.onPickerChange(e, data)}
            value={data.inputValue}
          >
            <List.Item
              arrow="horizontal"
              style={{ border: '1px solid #e5e5e5', borderRadius: 4 }}
            >
              {data.fieldTitle}
            </List.Item>
          </Picker>
        )
      case 'CheckBox':
        const checkboxData = []
        data.multipleValue.map((item, index) => {
          checkboxData.splice(index, 0, item.name)
        })
        return (
          <div className={styles.choiceField}>
            <CheckboxGroup
              value={data.inputValue}
              onChange={(e) => this.onCheckBoxChange(e, data)}
            >
              {checkboxData.map((item, index) => (
                <Checkbox
                  className={styles.choiceFieldItem}
                  key={item}
                  value={item}
                  style={{ width: 100 / data.showType + '%' }}
                >
                  {item}
                </Checkbox>
              ))}
            </CheckboxGroup>
          </div>
        )
      case 'NumberField':
        var initialValue = ''
        if (data.inputValue.length > 0) {
          initialValue = data.inputValue[0]
        }
        return (
          <Form.Item
            name={[data.fieldId]}
            initialValue={initialValue}
            type="number"
          >
            <Input
              onBlur={() => window.scrollTo(0, 0)}
              id={'input_' + data.fieldId}
              style={{ overflowX: 'hidden' }}
              className={[
                `${styles.textField}`,
                data.isReadOnly ? `${styles.readOnly}` : ``,
              ].join(' ')}
              onChange={(e) => {
                data.inputValue = [e.target.value]
                this.updateExField(data)
              }}
            />
          </Form.Item>
        )
      case 'AccessoryField':
        return (
          <Upload
            multiple="true"
            action={process.env.API_HOST + '/file/upload.api'}
            onChange={(info) => this.onUploadChange(info, data)}
            data={{ authtoken: this.sid }}
            defaultFileList={data.inputValue}
            onDownload={(file) => {
              const url =
                process.env.API_HOST + _getDownloadPath(file.url, file.name)
              const link = document.createElement('a')
              link.href = url
              link.download = file.name
              link.click()
            }}
            onPreview={(file) => {
              previewFileByOW365(file)
            }}
          >
            {data.inputValue.length >= 10 ? null : (
              <Button>
                <UploadOutlined />
              </Button>
            )}
          </Upload>
        )
      case 'BusinessField':
        const businessData = []
        data.multipleValue.map((item, index) => {
          businessData.splice(index, 0, item.name)
        })
        return (
          <div
            className={[
              `${styles.choiceField}`,
              data.isReadOnly ? `${styles.readOnly}` : ``,
            ].join(' ')}
          >
            <CheckboxGroup
              value={data.inputValue}
              onChange={(e) => this.onCheckBoxChange(e, data)}
            >
              {businessData.map((item, index) => (
                <Checkbox
                  disabled={data.isReadOnly}
                  className={styles.choiceFieldItem}
                  key={item}
                  value={item}
                  style={{ width: '50%' }}
                >
                  {item}
                </Checkbox>
              ))}
            </CheckboxGroup>
          </div>
        )
      case 'DateField':
        var valueStr = ''
        var value = new Date()
        if (data.inputValue[0]) {
          value = new Date(data.inputValue[0])
          valueStr = moment(data.inputValue[0]).format('YYYY-MM-DD')
        }
        return (
          <span>
            {isQiyeweixinApp() ? (
              <DatePicker
                format
                mode="date"
                value={value}
                onChange={(date) => {
                  data.inputValue = [date.getTime()]
                  this.updateExField(data)
                }}
              >
                <Input
                  type="text"
                  readOnly
                  className={styles.textField}
                  value={valueStr}
                  style={{ overflowX: 'unset' }}
                  allowClear
                  onChange={() => {
                    data.inputValue = []
                    this.updateExField(data)
                  }}
                />
              </DatePicker>
            ) : (
              <Space direction="vertical" style={{ width: '100%' }}>
                <PcDatePicker
                  style={{ overflowX: 'hidden' }}
                  format="YYYY-MM-DD"
                  className={styles.textField}
                  defaultValue={moment(data.inputValue[0])}
                  onChange={(date, dateString) => {
                    data.inputValue = [moment(date).valueOf()]
                    this.updateExField(data)
                  }}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                />
              </Space>
            )}
          </span>
        )
      case 'DateTimeField':
        var valueStr = ''
        var value = new Date()
        if (data.inputValue[0]) {
          value = new Date(data.inputValue[0])
          valueStr = moment(data.inputValue[0]).format('YYYY-MM-DD HH:mm')
        }
        return (
          <span>
            {isQiyeweixinApp() ? (
              <DatePicker
                format
                mode="datetime"
                value={value}
                onChange={(date) => {
                  data.inputValue = [date.getTime()]
                  this.updateExField(data)
                }}
              >
                <Input
                  type="text"
                  readOnly
                  className={styles.textField}
                  value={valueStr}
                  style={{ overflowX: 'unset' }}
                  allowClear
                  onChange={() => {
                    data.inputValue = []
                    this.updateExField(data)
                  }}
                />
              </DatePicker>
            ) : (
              <Space direction="vertical" style={{ width: '100%' }}>
                <PcDatePicker
                  showTime
                  style={{ overflowX: 'hidden' }}
                  format="YYYY-MM-DD HH:mm"
                  className={styles.textField}
                  defaultValue={moment(data.inputValue[0])}
                  onChange={(date, dateString) => {
                    data.inputValue = [moment(date).valueOf()]
                    this.updateExField(data)
                  }}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                />
              </Space>
            )}
          </span>
        )
      case 'SectionBreak':
        return (
          <div>
            <div className={styles.sectionField}></div>
            <div className={styles.sectionFieldLabel}>{data.fieldTitle}</div>
          </div>
        )
      case 'StaffField':
        return (
          <div>
            {data.inputValue.length > 0 ? (
              <div className={styles.relativeField}>
                {data.inputValue.map((item, index) => (
                  <div key={index} className={styles.relativeList}>
                    <span className={styles.relativeListItemIcon}></span>
                    {item.name}
                  </div>
                ))}
              </div>
            ) : (
              ''
            )}
            <div
              className={styles.childFormItemAdd}
              onClick={(e) => {
                if (data.isReadOnly) {
                  Toast.info('只读字段', 1)
                  return
                }
                e.preventDefault()
                this.setState(
                  {
                    selectedData: data.inputValue,
                    selectedExtra: { type: 2, data },
                  },
                  () => setTimeout(this.selectMemberModal.showModal(), 20)
                )
              }}
            >
              点击添加
            </div>
          </div>
        )
      case 'ImageField':
        if (!data.inputValue) {
          data.inputValue = []
        }
        return (
          <ul className={styles.impression}>
            {data.inputValue.map((item, index) => {
              return (
                <li
                  className={styles.imageList}
                  style={{ borderBottom: 'none', marginTop: '4px' }}
                >
                  <a
                    className={styles.remove_icon_minus}
                    onClick={() => {
                      data.inputValue.splice(index, 1)
                      this.updateExField(data)
                    }}
                  ></a>
                  <p className={styles.img}>
                    {isQiyeweixinApp() ? (
                      <img
                        className={[
                          `${styles.image_addIcon}`,
                          `${styles.previewImagesField}`,
                        ].join(' ')}
                        src={
                          process.env.API_HOST +
                          _getDownloadPath(item.url, item.name)
                        }
                        onClick={() => this.previewImage(data.inputValue, item)}
                      ></img>
                    ) : (
                      <Zmage
                        src={ALI_OSS_DOWNLOAD + item.url}
                        backdrop="rgba(0,0,0,.5)"
                        className={[
                          `${styles.image_addIcon}`,
                          `${styles.previewImagesField}`,
                        ].join(' ')}
                      ></Zmage>
                    )}
                  </p>
                </li>
              )
            })}
            {isQiyeweixinApp() ? (
              <div className={styles.add_image_box}>
                <div
                  className={[
                    `${styles.image_addIcon}`,
                    `${styles.disabled}`,
                  ].join(' ')}
                  onClick={() => {
                    this.addImageOnClick(data)
                  }}
                ></div>
              </div>
            ) : (
              <Upload
                multiple="true"
                action={process.env.API_HOST + '/file/upload.api'}
                onChange={(info) => this.onUploadChange(info, data)}
                accept="image/*,.pdf"
                data={{ authtoken: this.sid }}
                showUploadList={false}
              >
                <div className={styles.add_image_box}>
                  <div
                    className={[
                      `${styles.image_addIcon}`,
                      `${styles.disabled}`,
                    ].join(' ')}
                  ></div>
                </div>
              </Upload>
            )}
          </ul>
        )
      case 'OcrInvoice':
        return (
          <span>
            <ul className={styles.impression}>
              {data.inputValue.map((item, index) => {
                return (
                  <li
                    className={styles.imageList}
                    style={{ borderBottom: 'none', marginTop: '4px' }}
                  >
                    {item.status !== 'done' ? (
                      <p
                        className={styles.img}
                        style={{ textAlign: 'center', paddingTop: 15 }}
                      >
                        <Spin
                          indicator={
                            <LoadingOutlined style={{ fontSize: 24 }} spin />
                          }
                        />
                      </p>
                    ) : (
                      <span>
                        <a
                          className={styles.remove_icon_minus}
                          onClick={() => {
                            data.inputValue.splice(index, 1)
                            if (
                              this.state.removeFileList.indexOf(item.url) < 0
                            ) {
                              this.state.removeFileList.push(item.url)
                              this.setState({
                                removeFileList: this.state.removeFileList,
                              })
                            }
                            this.updateExField(data)
                          }}
                        ></a>
                        <p className={styles.img}>
                          {typeof item.url === 'string' &&
                          item.url.toLowerCase().endsWith('.pdf') ? (
                            <span>
                              <img
                                className={[
                                  `${styles.image_addIcon}`,
                                  `${styles.previewImagesField}`,
                                ].join(' ')}
                                src={require('../../assets/img/pdf.png')}
                                onClick={() => previewFileByOW365(item)}
                              />
                            </span>
                          ) : isQiyeweixinApp() ? (
                            <img
                              className={[
                                `${styles.image_addIcon}`,
                                `${styles.previewImagesField}`,
                              ].join(' ')}
                              src={
                                process.env.API_HOST +
                                _getDownloadPath(item.url, item.name)
                              }
                              onClick={() =>
                                this.previewImage(data.inputValue, item)
                              }
                            ></img>
                          ) : (
                            <Zmage
                              src={ALI_OSS_DOWNLOAD + item.url}
                              backdrop="rgba(0,0,0,.5)"
                              className={[
                                `${styles.image_addIcon}`,
                                `${styles.previewImagesField}`,
                              ].join(' ')}
                            ></Zmage>
                          )}
                        </p>
                      </span>
                    )}
                  </li>
                )
              })}
              <Upload
                multiple="true"
                action={process.env.API_HOST + '/file/upload.api'}
                onChange={(info) => this.onOcrVatInvoiceChange(info, data)}
                accept="image/*,.pdf"
                data={{ authtoken: this.sid }}
                showUploadList={false}
              >
                <div className={styles.add_image_box}>
                  <div
                    className={[
                      `${styles.image_addIcon}`,
                      `${styles.disabled}`,
                    ].join(' ')}
                  ></div>
                </div>
              </Upload>
            </ul>
            {data.inputValue.map((item, index) => {
              if (item.ocrStatus) {
                return (
                  <InvoiceComponent
                    index={index}
                    invoiceInfo={item.invoiceInfo}
                  ></InvoiceComponent>
                )
              } else {
                return <div></div>
              }
            })}
          </span>
        )
      default:
        return <span>无法识别</span>
    }
  }

  render() {
    return (
      <div className={styles.approveDialogPop}>
        <div className={styles.approveDialog}>
          <div className={styles.selectBoxContent}>
            <p className={styles.chooseNodeListUITopTitle}>{this.actionName}</p>
            {this.props.actionType === 2 &&
            this.state.preFlowNodes.length > 0 ? (
              <span>
                <p className={styles.chooseNodeListUITopTitle}>
                  选择退回的节点<span className={styles.tip}>*</span>
                </p>
                <div style={{ padding: 16, width: '100%' }}>
                  <Select
                    value={this.state.backFlowNode}
                    style={{ width: '100%' }}
                    onChange={(value) => this.setState({ backFlowNode: value })}
                  >
                    {this.state.preFlowNodes.map((i) => (
                      <Option key={i.value} value={i.value}>
                        {i.label}
                      </Option>
                    ))}
                  </Select>
                </div>
              </span>
            ) : (
              <span></span>
            )}
            {this.props.actionType === 0 ? (
              <p
                className={[
                  `${styles.retractMsg}`,
                  `${styles.approveMessage}`,
                ].join(' ')}
              >
                关闭流程后申请单状态为「已关闭」
              </p>
            ) : (
              ''
            )}
            {this.props.actionType === 3 || this.props.actionType === 4 ? (
              <div>
                <Radio.Group
                  style={{ padding: '0px 15px 15px 15px' }}
                  defaultValue={this.state.signType}
                  onChange={this.onSignTypeChange}
                >
                  {this.props.actionType === 3 ? (
                    <Radio className={styles.radioStyle} value={1}>
                      加会签(在当前节点中添加处理人)
                    </Radio>
                  ) : (
                    ''
                  )}
                  <Radio className={styles.radioStyle} value={2}>
                    加前签(在当前节点之前添加处理人)
                  </Radio>
                  {this.props.actionType === 3 ? (
                    <Radio className={styles.radioStyle} value={3}>
                      加后签(在当前节点之后添加处理人)
                    </Radio>
                  ) : (
                    ''
                  )}
                </Radio.Group>
                <div className={styles.userSelectWap}>
                  <div className={styles.userSelectListView}>
                    {this.state.signUsers.map((item, index) => (
                      <div key={index} className={styles.userContentWrap}>
                        <div className={styles.userSelectView}>
                          <a
                            className={styles.remove_icon}
                            onClick={() => {
                              this.state.signUsers.splice(index, 1)
                              this.setState({ signUsers: this.state.signUsers })
                            }}
                          ></a>
                          <p className={styles.img}>
                            <img
                              className={styles.user_select_img}
                              src={item.avatar}
                            ></img>
                          </p>
                          <p className={styles.userInfo_name}>{item.name}</p>
                        </div>
                      </div>
                    ))}
                    <div className={styles.userContentWrap}>
                      <div
                        onClick={(e) => {
                          e.preventDefault()
                          this.setState(
                            {
                              selectedData: this.state.signUsers,
                              selectedExtra: { type: 3 },
                            },
                            () =>
                              setTimeout(this.selectMemberModal.showModal(), 20)
                          )
                        }}
                        className={styles.userSelectAdd}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}
            {(!this.props.currentNode.signType &&
              this.props.actionType === 1) ||
            (this.props.actionType === 3 && this.state.signType !== 2)
              ? this.state.exFields.map((item, index) => (
                  <div className={styles.formGroup} key={item.fieldId}>
                    {item.fieldType !== 'SectionBreak' ? (
                      <div className={styles.formLabel}>
                        <label className={styles.controlLabel}>
                          {item.fieldTitle}
                          {item.isRequired === 'true' ? (
                            <span className={styles.colorRed}> *</span>
                          ) : (
                            ''
                          )}
                        </label>
                      </div>
                    ) : (
                      ''
                    )}
                    <Form className={styles.fieldContent}>
                      {this.renderExField(item)}
                    </Form>
                    <div className={styles.helpBlock}></div>
                  </div>
                ))
              : ''}
            {this.state.nextFlowNodes.length > 0 ? (
              <div>
                {this.state.nextFlowNodes.map((item, index) => (
                  <div key={index}>
                    <div className={styles.user_select_top}>
                      <div className={styles.user_cell_view}>
                        <p data-v-21c96e3a="" className={styles.title}>
                          {item.flowNodeName} 处理人
                          <span className={styles.required_mark}>*</span>
                        </p>
                      </div>
                      <div className={styles.user_cell_fr}></div>
                    </div>
                    <div className={styles.user_select_wap}>
                      <div className={styles.user_select_list_view}>
                        {item.users.map((subItem, i) => (
                          <div key={i} style={{ display: 'inline' }}>
                            <div className={styles.user_select_view}>
                              <div>
                                <a
                                  className={styles.remove_icon}
                                  style={{ display: 'none' }}
                                ></a>
                                <p className={styles.img}>
                                  <img
                                    src={subItem.avatar}
                                    className={styles.user_select_img}
                                  />
                                </p>
                                <p className={styles.userInfo_name}>
                                  {subItem.name}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              ''
            )}
            {this.state.allowApprovalComments ? (
              <div className={styles.dialog_textarea}>
                <textarea
                  cols="30"
                  rows="2"
                  maxLength="1000"
                  value={this.state.actionDesc}
                  onChange={(e) => {
                    this.setState({ actionDesc: e.target.value })
                  }}
                ></textarea>
                <p className={styles.dialog_textarea_counter}>
                  <span>{this.state.actionDesc.length}</span>/1000
                </p>
              </div>
            ) : (
              ''
            )}
          </div>
          <div className={styles.btn_box}>
            <div className={styles.btn_tab}>
              <Button
                style={{ flex: 1, height: 44, marginRight: 15, fontSize: 18 }}
                onClick={() => this.props.close()}
              >
                取消
              </Button>
              <Button
                style={{ flex: 1, height: 44, fontSize: 18 }}
                type="primary"
                loading={this.state.isSubmitting}
                onClick={async () => {
                  this.setState({ isSubmitting: true })
                  if (
                    this.props.actionType === 3 ||
                    this.props.actionType === 4
                  ) {
                    if (this.state.signUsers.length === 0) {
                      Toast.info('请选择审批人', 1)
                      this.setState({ isSubmitting: false })
                      return
                    }
                  }
                  if (this.state.exFields.length > 0) {
                    if (
                      (this.props.actionType === 1 &&
                        !this.props.currentNode.signType) ||
                      (this.props.actionType === 3 && this.state.signType !== 2)
                    ) {
                      for (var i = 0; i < this.state.exFields.length; i++) {
                        if (
                          this.state.exFields[i].fieldType === 'SectionBreak'
                        ) {
                          continue
                        }
                        if (this.state.exFields[i].isRequired !== 'true') {
                          continue
                        }
                        if (
                          !this.state.exFields[i].inputValue ||
                          this.state.exFields[i].inputValue.length === 0 ||
                          !this.state.exFields[i].inputValue[0]
                        ) {
                          Toast.info(
                            '请填写' + this.state.exFields[i].fieldTitle,
                            1
                          )
                          this.setState({ isSubmitting: false })
                          return
                        }

                        if (this.state.exFields[i].fieldType === 'OcrInvoice') {
                          for (
                            let index = 0;
                            index < this.state.exFields[i].inputValue.length;
                            index++
                          ) {
                            const element =
                              this.state.exFields[i].inputValue[index]
                            if (!element.url || !element.invoiceInfo) {
                              Toast.info(
                                '请重新填写' +
                                  this.state.exFields[i].fieldTitle,
                                1
                              )
                              this.setState({ isSubmitting: false })
                              return
                            }
                          }
                        }
                      }
                    }
                  }
                  this.props.submit(
                    this.state.actionDesc,
                    this.state.backFlowNode,
                    this.state.exFields,
                    this.state.signType,
                    this.state.signUsers
                  )
                }}
              >
                确定
              </Button>
            </div>
          </div>
        </div>
        <SelectMember
          triggerRef={this.bindRef}
          callback={this.updateSelectedData}
          selectedData={this.state.selectedData}
          sid={this.sid}
          extra={this.state.selectedExtra}
        />
      </div>
    )
  }
}

export default withCookies(ApproveDialog)

